import Vue from 'vue';
import Component from 'vue-class-component';
import * as i18next from 'i18next';
import router from 'src/router';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class Error404Component extends Vue {
    mounted() {
        window.document.title = i18next.t('error_404_notfound');
    }
    get canGoBack() {
        return window.history.length > 1;
    }
    goHome() {
        router.push('/');
    }
}
